import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const Kommunaler_Wald_Icon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M107.283 16L135.338 78.8861H79.2269L107.283 16ZM76.8008 124.621C82.9743 118.568 86.8045 110.134 86.8045 100.806C86.8045 95.6888 85.6521 90.841 83.5926 86.5078H130.151L146.349 124.621H113.001V145.579H101.567V124.621H76.8008Z" fill={color} fillOpacity="0.8" />
        <path fillRule="evenodd" clipRule="evenodd" d="M23.4331 55.0594C23.4331 42.9561 33.2447 33.1445 45.348 33.1445C57.4512 33.1445 67.2628 42.9561 67.2628 55.0594V75.6556C74.2699 81.7691 78.6974 90.7645 78.6974 100.794C78.6974 116.928 67.2406 130.385 52.0188 133.476V147.485H40.585V133.805C24.4236 131.493 12 117.595 12 100.794C12 90.7652 16.4269 81.7703 23.4331 75.6569V55.0594Z" fill={color} fillOpacity="0.8" />
    </svg>
);

export default Kommunaler_Wald_Icon;
